<template>
    <div class="row tocaselectorales">
        <!--Listado de vinculos-->
        <ListadoDeVinculos v-if="seccionDeLaPaginaWeb.ContenidosDeLaPaginaWeb.length > 0" :seccionDeLaPaginaWeb="seccionDeLaPaginaWeb"></ListadoDeVinculos>
        <ul class="nav nav-tabs col-12 noRequierePadding" role="tablist" v-if="seccionDeLaPaginaWeb.SeccionesQueMePertenecen.length > 0">
            <li v-for="seccionQueMePertenece in seccionDeLaPaginaWeb.SeccionesQueMePertenecen" v-bind:key="seccionQueMePertenece.SeccionDeLaPaginaWebId" v-bind:class="CreaLaClaseDeCol(seccionDeLaPaginaWeb.TamanoDeMiDescendiente, false)" class="nav-item bordesPrimarios noRequierePadding">
                <a v-on:click="seccionConContenido = seccionQueMePertenece" class="col-12 noRequierePadding nav-link" data-toggle="tab" role="tab" aria-selected="true" >{{seccionQueMePertenece.NombreDeLaSeccion}}</a>
            </li>
        </ul>
        <div v-if="EstaVacioLosDatos(seccionConContenido) == false" class="col-12 contenidoDeLaInformacion noRequierePadding">
            <!--Listado de vinculos-->
            <!-- <ListadoDeVinculos :seccionDeLaPaginaWeb="seccionConContenido"></ListadoDeVinculos> -->
            <div v-for="contenido in seccionConContenido.ContenidosDeLaPaginaWeb" v-bind:key="contenido.ContenidosDeLaPaginaWebId" v-bind:class="CreaLaClaseDeCol(seccionConContenido.TamanoDeMiDescendiente, true)" class="acomodaLasTocasElectorales col-6 col-sm-4 col-md-3">
                <div class="tarjetaDeLaTocaElectoral col-12 noRequierePadding">
                    <div v-if="contenido.ArchivosDeContenidoDeLaPaginaWeb.length > 0" class="text-left">
                        <a v-for="archivoDeContenidoDeLaPaginaWeb in contenido.ArchivosDeContenidoDeLaPaginaWeb" v-bind:key="archivoDeContenidoDeLaPaginaWeb.ArchivoDeContenidoDeLaPaginaWebId" class="btn btn-success descargaDelArchivo col-md-12 col-12 noRequierePadding" v-on:click="AbrirDocumento(archivoDeContenidoDeLaPaginaWeb.RutaDeArchivoCarpeta, '_self')">
                            <i class="fas fa-file-download"></i>&nbsp;{{archivoDeContenidoDeLaPaginaWeb.TextoDelVinculo}}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ListadoDeVinculos from "@/components/PaginaOficial/PaginaInformativa/Formatos/ListadoDeVinculos.vue"
import comun from "@/../static/js/comun";
export default {
    data() { 
      return {
        seccionConContenido: Object
      }
    },
    components: {
        ListadoDeVinculos
    },
    props: {
        seccionDeLaPaginaWeb: Object
    }, 
    methods: {
        CreaLaClaseDeCol: function(tamanoDeLaColumna, colImpuesto) {
            if (colImpuesto)
                return "col-lg-2 col-xl-2";
            else
                return "col-md-" + tamanoDeLaColumna + " col-" + tamanoDeLaColumna;
        }, 
        EstaVacioLosDatos: function(objeto) {
            return objeto === undefined || objeto === null || Object.keys(objeto).length === 0 ? true : false;
        },
        AbrirDocumento: function(vinculo, formaDeApertura) {
            comun.DescargarDocumentoPDF(vinculo)
           // window.open(vinculo, formaDeApertura);
        }
    }
}
</script>

<style scoped>
  .tocaselectorales {
    width: 100%;
  }

  ul {
      text-align: center;
  }

  .noRequierePadding {
        padding-left: 0 !important;
        padding-right: 0 !important;
    }

  .nav-tabs {
      border: none;
  }

  .nav-item {
      margin-bottom: 0;
      padding-bottom: 0 !important;
      color: white !important;
  }

  .nav-link {
    background-color: rgb(34,34,34) !important;
    color: white;
    font-weight: 500;
  }

  .nav-link:hover {
      border-bottom: 1px solid rgb(63, 63, 63) !important;
      background-color: rgb(63, 63, 63) !important;
      border-color: rgb(63, 63, 63) rgb(63, 63, 63) rgb(63, 63, 63) rgb(63, 63, 63) !important;
  }

  .active {
    border: none !important;
    border-bottom: 1px solid rgb(63, 63, 63) !important;
    background-color: rgb(63, 63, 63) !important;
    border-color: rgb(63, 63, 63) rgb(63, 63, 63) rgb(63, 63, 63) rgb(63, 63, 63) !important;
    color:white !important;
  }

  .bordesPrimarios {
    border-radius: 5px 5px 0 0;
    border: .5px solid #dee2e6 !important;
    background-color: rgb(34,34,34) !important;
  }

  .contenidoDeLaInformacion {
    border: 1px solid rgb(160, 160, 160) !important;
    background-color: rgba(0,0,0,.05) !important;
  }

  .acomodaLasTocasElectorales {
    display: inline-flex;
    padding: 20px;
  }

  .tarjetaDeLaTocaElectoral {
    display: block;
    border: 1px solid rgb(194, 194, 194);
    background-color: white;
  }

  .descargaDelArchivo {
    white-space: normal;
  }

  .btn {
      border-radius: 0px !important;
  }

  .btn-success {
      padding-left: 10px !important;
      padding-right: 10px !important    ;
      color: white !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/PaginaOficial/PaginaInformativa/Formatos/TocasElectorales.vue